
<!-- CABEÇALHO MOBILE -->
<div class="admin-mobile-header">
  <button
    type="button"
    class="sidebar-open-btn"
    (click)="alternarMenu()"
    aria-label="Abrir menu"
    [attr.aria-expanded]="menuAberto"
  >
    <svg
      width="22" height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d="M4 7h16M4 12h16M4 17h16"/>
    </svg>
  </button>

  <span class="admin-mobile-title">
    MENU ADMINISTRATIVO
  </span>
</div>

<!-- OVERLAY MOBILE -->
@if (menuAberto) {
  <div
    class="sidebar-overlay"
    (click)="fecharMenu()"
  ></div>
}

<!-- SIDEBAR -->
<aside
  class="sidebar"
  [class.aberto]="menuAberto"
>
  <!-- LOGO -->
  <div class="sidebar-logo">
    <div class="logo-mark">
      PC
    </div>

    <div class="logo-text">
      <strong>Paraíso do Cerrado</strong>
      <span>Backoffice</span>
    </div>

    <button
      type="button"
      class="sidebar-close-btn"
      (click)="fecharMenu()"
      aria-label="Fechar menu"
    >
      <svg
        width="20" height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M18 6 6 18M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- NAVEGAÇÃO -->
  <nav class="sidebar-menu">

    <!-- DASHBOARD -->
    <a
      class="menu-item"
      routerLink="/admin/dashboard"
      routerLinkActive="ativo"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="7" height="9" rx="1.5"/>
          <rect x="14" y="3" width="7" height="5" rx="1.5"/>
          <rect x="14" y="12" width="7" height="9" rx="1.5"/>
          <rect x="3" y="16" width="7" height="5" rx="1.5"/>
        </svg>
      </span>
      <span>Dashboard</span>
    </a>

    <!-- ACOMODAÇÕES -->
    <a
      class="menu-item"
      routerLink="/admin/quartos"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 10.5 12 3l9 7.5"/>
          <path d="M5 9.5V20h14V9.5"/>
          <path d="M9 20v-7h6v7"/>
        </svg>
      </span>
      <span>Acomodações</span>
    </a>

    <!-- TARIFAS -->
    <a
      class="menu-item"
      routerLink="/admin/tarifas-data"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="5" width="18" height="14" rx="2"/>
          <path d="M3 10h18"/>
          <path d="M12 13v3"/>
          <path d="M10.5 14.5h3"/>
        </svg>
      </span>
      <span>Tarifas por data</span>
    </a>

    <!-- RESERVAS -->
    <a
      class="menu-item"
      routerLink="/admin/reservas"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="5" width="18" height="16" rx="2"/>
          <path d="M7 3v4M17 3v4M3 10h18"/>
          <path d="m9 15 2 2 4-4"/>
        </svg>
      </span>
      <span>Reservas</span>
    </a>


    <!-- NOVA RESERVA -->
    <a
      class="menu-item"
      routerLink="/admin/criar-reserva"
      routerLinkActive="ativo"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="fecharMenu()"
    >
  <span class="menu-icon">
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="5" width="18" height="16" rx="2"/>
      <path d="M7 3v4M17 3v4M3 10h18"/>
      <path d="M12 13v6M9 16h6"/>
    </svg>
  </span>

      <span>Criar Reserva</span>
    </a>


    <!-- DISPONIBILIDADE -->
    <a
      class="menu-item"
      routerLink="/admin/disponibilidade-meses"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="4" width="18" height="17" rx="2"/>
          <path d="M8 2v4M16 2v4M3 9h18"/>
          <path d="M8 13h2M14 13h2M8 17h2M14 17h2"/>
        </svg>
      </span>
      <span>Disponibilidade de meses</span>
    </a>

    <!-- CUPONS -->
    <a
      class="menu-item"
      routerLink="/admin/cupons"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 12 12 20 3 11V4h7z"/>
          <circle cx="7.5" cy="8" r="1"/>
          <path d="m10 15 5-5"/>
        </svg>
      </span>
      <span>Cupons</span>
    </a>

    <!-- PACOTES ADICIONAIS -->
    <a
      class="menu-item"
      routerLink="/admin/pacotes"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="8" width="18" height="13" rx="2"/>
          <path d="M12 8v13M3 12h18"/>
          <path d="M12 8H8a2.5 2.5 0 1 1 2.4-3.2L12 8Z"/>
          <path d="M12 8h4a2.5 2.5 0 1 0-2.4-3.2L12 8Z"/>
        </svg>
      </span>
      <span>Pacotes adicionais</span>
    </a>

    <!-- REGRAS DE MÍNIMO DE NOITES -->
    <a
      class="menu-item"
      routerLink="/admin/regras-minimo-noites"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.5 14A8.5 8.5 0 0 1 10 3.5 8.5 8.5 0 1 0 20.5 14Z"/>
          <path d="M17 3v4M15 5h4"/>
        </svg>
      </span>
      <span>Regras de mínimo de noites</span>
    </a>

    <!-- SPLIT DE PAGAMENTOS -->
    <a
      class="menu-item"
      routerLink="/admin/split-pagamentos"
      routerLinkActive="ativo"
      (click)="fecharMenu()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="3" width="18" height="6" rx="2"/>
          <path d="M12 9v5"/>
          <path d="M6 14h12"/>
          <path d="M6 14v3M18 14v3"/>
          <rect x="2" y="17" width="8" height="4" rx="1"/>
          <rect x="14" y="17" width="8" height="4" rx="1"/>
        </svg>
      </span>
      <span>Split de Pagamentos</span>
    </a>

  </nav>

  <!-- RODAPÉ -->
  <div class="sidebar-footer">
    <button
      type="button"
      class="menu-item sair"
      (click)="sair()"
    >
      <span class="menu-icon">
        <svg viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="1.8"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <path d="m16 17 5-5-5-5"/>
          <path d="M21 12H9"/>
        </svg>
      </span>
      <span>Sair</span>
    </button>
  </div>
</aside>
